define('lib/Podio.Viewport',['require','underscore','jquery','lib/LazyEventsHelper','lib/Podio.Event'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var LazyEventHelper = require('lib/LazyEventsHelper');
  var PodioEvent = require('lib/Podio.Event');

  var lazyEvents = LazyEventHelper.initialize();

  var ViewPortHelper = function(options) {
    this.options = options || {};
    this.options.offsets = this.options.offsets || {};
    this.elmWindow = $(window);
    this.options.elmViewport = this.options.elmViewport || this.elmWindow;
    this.register = {};

    return this;
  };

  _.extend(ViewPortHelper.prototype, {

    /**
     * Returns dimensions information of the "viewport" element
     * necessary for detecting position of an element inside it.
     * @param elmViewport Container element for detecting dimentions (can be window)
     * @returns {{isWindow: boolean, scrollTop: *, height: *, width: *, scrollLeft: *}}
     * @private
     */
    _getViewportInfo: function(elmViewport) {
      return {
        isWindow: $.isWindow(elmViewport.get(0)),
        scrollTop: elmViewport.scrollTop(),
        height: elmViewport.height(),
        width: elmViewport.width(),
        scrollLeft: elmViewport.scrollLeft()
      };
    },

    /**
     * Returns position information for a given element
     * inside a given viewport (by providing viewport dimensions)
     * @param elmTarget An element that information is required for
     * @param viewportInfo Dimentions information for the viewport
     * @returns {{isBelowFold: boolean, isBelowFoldTopEdge: boolean, isAboveTop: boolean, isRightOfViewPort: boolean, isLeftOfViewPort: boolean, isWithinViewportBottomEdge: boolean, isInViewport: boolean}}
     * @private
     */
    _getTargetInfo: function(elmTarget, viewportInfo) {
      if(!elmTarget || (elmTarget && !elmTarget.length) ) {
        return; // No element
      }

      var relativeToDocument = viewportInfo.isWindow;
      var offsetElement;
      if ( relativeToDocument ) {
        offsetElement = elmTarget.offset();
      } else {
        offsetElement = elmTarget.position();
      }

      var scrollTop = viewportInfo.scrollTop;

      var windowTopEdge = scrollTop;
      var windowBottomEdge = viewportInfo.height + scrollTop;
      var targetTopEdge = offsetElement.top;
      var targetBottomEdge = targetTopEdge + elmTarget.outerHeight(true);

      var isBelowFold = windowBottomEdge <= targetBottomEdge + (this.options.offsets.bottom ? this.options.offsets.bottom : 0);
      var isBelowFoldTopEdge = windowBottomEdge <= targetTopEdge + (this.options.offsets.bottom ? this.options.offsets.bottom : 0);
      var isAboveTop = windowTopEdge >= offsetElement.top + (this.options.offsets.top ? this.options.offsets.top : 0);
      var isRightOfViewPort = viewportInfo.width <= offsetElement.left + elmTarget.outerWidth(true);
      var isLeftOfViewPort = viewportInfo.scrollLeft > offsetElement.left;

      var isWithinViewportBottomEdge = windowBottomEdge >= targetBottomEdge;
      var isInViewport = !isBelowFold && !isAboveTop && !isRightOfViewPort && !isLeftOfViewPort;

      return {
        isBelowFold: isBelowFold,
        isBelowFoldTopEdge: isBelowFoldTopEdge,
        isAboveTop: isAboveTop,
        isRightOfViewPort: isRightOfViewPort,
        isLeftOfViewPort: isLeftOfViewPort,
        isWithinViewportBottomEdge: isWithinViewportBottomEdge,
        isInViewport: isInViewport
      };
    },

    /**
     * Is called when a scroll event happens on any registered context element
     * Will get read viewport dimensions only once, read properties for each target
     * and if they change to true notify the subscribers.
     * @param targetId
     * @param e Event
     * @private
     */
    _onScroll: function(targetId, e) {
      var elmScrollTarget;
      var viewportInfo;

      if (targetId === 'window') {
        elmScrollTarget = this.elmWindow;
      } else {
        elmScrollTarget = $(e.target);
      }

      viewportInfo = this._getViewportInfo(elmScrollTarget);

      this.register[targetId].forEach(this._notifySubscriber.bind(this, viewportInfo));
    },

    /**
     * Notifies a single subscriber if a value for the subscribed property changes
     * @param viewportInfo Cached viewport data for a certain target
     * @param options Subscription details like target and callback function
     * @private
     */
    _notifySubscriber: function(viewportInfo, options) {
      var info = this._getTargetInfo(options.elmTarget, viewportInfo);

      // was the previous value false but the current true, call the callback
      if (!options.prevValue && info[options.event]) {
        options.fn();
      }

      options.prevValue = info[options.event];
    },

    /**
     * Is called when a first listener is subscribing to a given scroll context
     * Will use an existing listener for the window scrolling if the context is a window.
     * @param elmScrollTarget
     * @param targetId
     * @private
     */
    _bindToScroll: function(elmScrollTarget, targetId) {
      if (targetId === 'window') {
        PodioEvent.bind(PodioEvent.Types.scroll, this._onScroll.bind(this, targetId));
      } else {
        elmScrollTarget.on('scroll.viewport', _.debounce(this._onScroll, 500).bind(this, targetId));
      }
    },

    /**
     * Is called when the last listener has unsubscribed from a given scroll context
     * @param elmScrollTarget
     * @param targetId
     * @private
     */
    _unbindFromScroll: function(elmScrollTarget, targetId) {
      if (targetId === 'window') {
        PodioEvent.unbind(PodioEvent.Types.scroll, this._onScroll);
      } else {
        elmScrollTarget.off('scroll.viewport', this._onScroll);
        elmScrollTarget.removeData('targetId');
      }
    },

    /**
     * For each scroll target (associated with a randomly generated ID) it will store the event name,
     * the target to evaluated properties on and the callback function to call for each subscription.
     * @param targetId
     * @param options
     * @private
     */
    _registerEvent: function(targetId, options) {
      if (_.isArray(this.register[targetId])) {
        this.register[targetId].push(options);
      } else {
        this.register[targetId] = [options];
      }
    },

    /**
     * Removes an event from the store identified by its name and the target for
     * evaulating properties.
     * @param targetId
     * @param event
     * @param elmTarget
     * @private
     */
    _unregisterEvent: function(targetId, event, elmTarget) {
      var index = _.findIndex(this.register[targetId], function(reg) {
        return reg.event === event && reg.elmTarget === elmTarget;
      });

      this.register[targetId].splice(index, 1);
    },

    /**
     * Will return one-time set of properties for a given target node
     * @param elmTarget The jQuery object a property is evaluated on
     * @returns {{isBelowFold: boolean, isBelowFoldTopEdge: boolean, isAboveTop: boolean, isRightOfViewPort: boolean, isLeftOfViewPort: boolean, isWithinViewportBottomEdge: boolean, isInViewport: boolean}}
     */
    getInfo: function(elmTarget) {
      return this._getTargetInfo(elmTarget, this._getViewportInfo(this.options.elmViewport));
    },

    /**
     * Lets users bind to one of the properties listed in the _getTargetInfo function above
     * and will notify them every time the property turns from false to true.
     * @param event The name of the property to subscribe to
     * @param elmTarget The jQuery object a property is evaluated on
     * @param fn A callback function to be called once the property turns true
     * @param elmScrollTarget The "context" node in which the scrolling that changes the properties will be evaulated in, window is default
     */
    on: function(event, elmTarget, fn, elmScrollTarget) {
      var targetId;
      var eventOptions;

      if (_.isUndefined(elmScrollTarget)) {
        targetId = 'window';
      } else if (!_.isUndefined(elmScrollTarget.data('targetId'))) {
        targetId = elmScrollTarget.data('targetId');
      } else {
        targetId = _.uniqueId('t');
      }

      // give a DOM node a unique ID
      if (!_.isUndefined(elmScrollTarget)) {
        elmScrollTarget.data('targetId', targetId);
      }

      lazyEvents.bindLazyEvent(targetId, this._bindToScroll.bind(this, elmScrollTarget));

      eventOptions = {
        event: event,
        elmTarget: elmTarget,
        fn: fn
      };

      this._registerEvent(targetId, eventOptions);

      // trigger an event to set the initial state on the new subscriber
      this._notifySubscriber(this._getViewportInfo(elmScrollTarget || this.elmWindow), eventOptions);
    },

    /**
     * Unsubscribe to an earlier subscribed event
     * @param event The name of the subscribed property
     * @param elmTarget he jQuery object a property is evaluated on
     * @param elmScrollTarget The "context" node in which the scrolling that changes the properties will be evaulated in, window is default
     */
    off: function(event, elmTarget, elmScrollTarget) {
      var targetId;

      if (_.isUndefined(elmScrollTarget)) {
        targetId = 'window';
      } else {
        targetId = elmScrollTarget.data('targetId');
      }

      lazyEvents.unbindLazyEvent(targetId, this._unbindFromScroll.bind(this, elmScrollTarget));

      this._unregisterEvent(targetId, event, elmTarget);
    }
  });

  return ViewPortHelper;

});

